import React from "react";
import Contact from "../../../src/components/Home/Contact";
import BreadCrumb from "../../../src/components/Shared/BreadCrumb";
import { useRouter } from "next/dist/client/router";

import { Col, Container, Row } from "react-bootstrap";
import Link from "next/link";
import Image from "next/future/image";

import searchIcon from "../../../src/assets/images/svg/search.svg";
import BlogItem from "../../../src/components/Home/BlogItem";
// import { blogData } from "../../../src/data";
import server from "../../../src/api/server";
const CategoryPage = ({
  blogsData,
  blogCategoryResponse,
  socialsData,
  error,
}) => {
  error && console.log(JSON.parse(error));
  const router = useRouter();
  const { locale } = router;
  const category = blogCategoryResponse;

  const renderBlogs = blogsData?.map((blog, index) => {
    return (
      <Col xl={4} lg={4} md={6} xs={12} key={blog.id}>
        <BlogItem blog={{ ...blog, count: index + 1 }} />
      </Col>
    );
  });

  return (
    <>
      <div className="blogs-page">
        <BreadCrumb
          title={category?.title?.[locale]}
          pageTitle={category?.title?.[locale]}
        />
        <div className="blogs-body">
          <Container>
            <Row>
              <Col xl={12} lg={12} md={12} xs={12}>
                <Row>{renderBlogs}</Row>
              </Col>
            </Row>
          </Container>
        </div>
        <Contact
          {...{
            socialsData,
          }}
        />
      </div>
    </>
  );
};
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking", // false or 'blocking'
  };
}

export const getStaticProps = async (ctx) => {
  try {
    const { id } = ctx.params;
    const blogResponse = await server.get(`/blogs/category/${id}`);
    const blogCategoryResponse = await server.get(`/categories/${id}`);
    const socialsResponse = await server.get("/settings/socials");
    return {
      revalidate: 1,
      props: {
        blogsData: blogResponse.data.data.blogs,
        blogCategoryResponse: blogCategoryResponse.data.data.category,
        socialsData: socialsResponse?.data?.data?.socials,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};
export default CategoryPage;
